module.exports = __webpack_public_path__ + "img/img-btnBg2@2x.039c43a8.png";